export default "__VITE_ASSET__786a37b8__"